<template>
  <modal-form-block position="center">
    <div class="glass-form-container">
      <div class="glass-form-content p-4 text-center">
        <div class="onboarding-icon-container mx-auto mb-3">
          <font-awesome-icon size="2x" icon="fa-solid fa-compass" class="text-white" />
        </div>

        <h4 class="text-white mb-2">Premiers pas avec Save My Money</h4>
        <p class="text-muted-glass mb-4">Voulez-vous découvrir comment utiliser l'application ?</p>

        <div class="d-flex justify-content-between gap-3">
          <button
            type="button"
            class="glass-btn-secondary rounded-5 py-2 px-3 w-100"
            data-cy="onboarding-prompt-skip"
            @click="$emit('skip')"
          >
            Passer
          </button>
          <button
            type="button"
            class="glass-btn-primary rounded-5 py-2 px-3 w-100"
            data-cy="onboarding-prompt-start"
            @click="$emit('start')"
          >
            Découvrir
          </button>
        </div>
      </div>
    </div>
  </modal-form-block>
</template>

<script>
// Component
import ModalFormBlock from '@/components/Form/ModalFormBlock.vue'

export default {
  name: 'OnboardingPromptModal',

  components: {
    ModalFormBlock
  },

  emits: ['skip', 'start']
}
</script>

<style scoped>
.glass-form-container {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  overflow: hidden;
  max-width: min(95vw, 420px);
  width: 100%;
  box-sizing: border-box;
}

.glass-form-content {
  background: linear-gradient(135deg, #1e2d43 0%, #2a4a6b 100%);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 24px;
}

.onboarding-icon-container {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: rgba(107, 180, 248, 0.8);
  border: 1px solid rgba(107, 180, 248, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(107, 180, 248, 0.3);
}
</style>
